// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
import { TournamentFragmentDoc } from './TournamentFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TournamentOptInMutationVariables = Types.Exact<{
  tournamentId: Types.Scalars['String']['input'];
  newValue: Types.Scalars['Boolean']['input'];
  currency?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type TournamentOptInMutation = { __typename?: 'Mutation', casinoTournamentsPublicSetOptInMutation?: { __typename?: 'CasinoTournamentsPublicSetOptInMutationPayload', success?: boolean, errors?: Array<{ __typename?: 'CasinoTournamentsPublicError', message?: string }>, tournament?: { __typename?: 'CasinoTournamentsPublicTournament', id: string, enabled?: boolean, openAt?: any, closeAt?: any, iAmOptedIn?: boolean, name?: string, prizeText?: string, activityType?: string, shortUrl?: string, backgroundImageSmall?: string, backgroundImageLarge?: string, rules?: string, leaderboardType?: string, myScore?: { __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean, leaderboardAfter?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }>, leaderboardBefore?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> }, prizes?: Array<{ __typename?: 'CasinoTournamentsPublicPrize', id: string, forPosition?: number, name?: string, link?: string, isDefaultPrizeBeforeUser?: string, automaticallyReleased?: boolean }>, leaderboard?: Array<{ __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean }> } } };


export const TournamentOptInMutationDocument = /*#__PURE__*/ gql`
    mutation TournamentOptInMutation($tournamentId: String!, $newValue: Boolean!, $currency: String) {
  casinoTournamentsPublicSetOptInMutation(
    input: {tournamentId: $tournamentId, newValue: $newValue, currency: $currency}
  ) {
    errors {
      message
    }
    success
    tournament {
      ...TournamentFragment
    }
  }
}
    ${TournamentFragmentDoc}`;
export type TournamentOptInMutationMutationFn = Apollo.MutationFunction<TournamentOptInMutation, TournamentOptInMutationVariables>;
export function useTournamentOptInMutation(baseOptions?: Apollo.MutationHookOptions<TournamentOptInMutation, TournamentOptInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TournamentOptInMutation, TournamentOptInMutationVariables>(TournamentOptInMutationDocument, options);
      }
export type TournamentOptInMutationHookResult = ReturnType<typeof useTournamentOptInMutation>;
export type TournamentOptInMutationMutationResult = Apollo.MutationResult<TournamentOptInMutation>;
export type TournamentOptInMutationMutationOptions = Apollo.BaseMutationOptions<TournamentOptInMutation, TournamentOptInMutationVariables>;